export default class ChatPanelState {
    /** 
     * 聊天内容 
     * @see ChatItemBasis
     */
    public chatList: JSX.Element[];
}


// WEBPACK FOOTER //
// ./src/node_modules/kts-platform-frame/display/components/ChatPanel/ChatPanelState.ts